import { $api } from "../generated/client";

const PAGE_SIZE = 20;

export type GetExportTasksFilters = {
  status?: string;
  sinceDays?: number;
};

export default function useGetExportTasks(
  shopId: string,
  jobId: string,
  filters: GetExportTasksFilters = {},
) {
  return $api.useInfiniteQuery(
    "get",
    "/shops/{shopId}/exports/{exportId}",
    {
      params: {
        path: { shopId, exportId: jobId },
        query: {
          limit: PAGE_SIZE,
          status: filters.status || undefined,
          sinceDays: filters.sinceDays,
        },
      },
    },
    {
      pageParamName: "before",
      initialPageParam: 0,
      getNextPageParam: (lastPage) =>
        lastPage.length === PAGE_SIZE
          ? lastPage[lastPage.length - 1].createdAt
          : undefined,
    },
  );
}
